module.exports = __webpack_public_path__ + "img/astral_3.840623f0.svg";